import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { UserNotesService } from 'app/core/user-notes/user-notes.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { forkJoin } from 'rxjs';
import { CompanyService } from './core/company/company.service';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const companyService = inject(CompanyService);
    const userNotesService = inject(UserNotesService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        companyService.getOwn(),
        userNotesService.getUserNotes(),
        // notificationsService.getAll(),
    ]);
};
